@use '@/styles/tokens' as *;

.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: $space-3;
  padding-top: $space-4;
}

.showing {
  display: flex;
  align-items: center;
  gap: $space-2;
  font-size: $font-size-md;
  color: var(--text-tertiary);
}

.rangeSelect {
  width: 96px;
}

.pager {
  display: flex;
  align-items: center;

  :global(.ant-pagination-item) {
    min-width: 32px;
    height: 32px;
    line-height: 32px;
    border: none;
    border-radius: $radius-lg;
    font-size: $font-size-md;

    a {
      color: var(--text-tertiary);
    }
  }

  :global(.ant-pagination-item-active) {
    background: $color-neutral-100;

    a {
      color: var(--text-primary);
    }
  }

  :global(.ant-pagination-prev),
  :global(.ant-pagination-next) {
    height: 32px;
    line-height: 32px;
  }
}

.nav {
  display: inline-flex;
  align-items: center;
  gap: $space-1;
  font-size: $font-size-md;
  color: var(--text-tertiary);
}
